// NavDistricts.js
import React from "react";
import { Link } from "react-router-dom";

const NavDistricts = () => {
  return (
    <fragment>
      <p>
        <Link
          to="/blades-in-the-dark-campaign-districts-barrowcleft"
          className="district-link"
        >
          Barrowcleft
        </Link>{" "}
        -{" "}
        <Link
          to="/blades-in-the-dark-campaign-districts-brightstone"
          className="district-link"
        >
          Brightstone
        </Link>{" "}
        -{" "}
        <Link
          to="/blades-in-the-dark-campaign-districts-charhollow"
          className="district-link"
        >
          Charhollow
        </Link>{" "}
        -{" "}
        <Link
          to="/blades-in-the-dark-campaign-districts-charterhall"
          className="district-link"
        >
          Charterhall
        </Link>{" "}
        -{" "}
        <Link
          to="/blades-in-the-dark-campaign-districts-coalridge"
          className="district-link"
        >
          Coalridge
        </Link>{" "}
        -{" "}
        <Link
          to="/blades-in-the-dark-campaign-districts-crowsfoot"
          className="district-link"
        >
          Crow's foot
        </Link>
      </p>
      <p>
        <Link
          to="/blades-in-the-dark-campaign-districts-docks"
          className="district-link"
        >
          Docks
        </Link>{" "}
        -{" "}
        <Link
          to="/blades-in-the-dark-campaign-districts-dunslough"
          className="district-link"
        >
          Dunslough
        </Link>{" "}
        -{" "}
        <Link
          to="/blades-in-the-dark-campaign-districts-nightmarket"
          className="district-link"
        >
          Nightmarket
        </Link>{" "}
        -{" "}
        <Link
          to="/blades-in-the-dark-campaign-districts-silkshore"
          className="district-link"
        >
          Silkshore
        </Link>{" "}
        -{" "}
        <Link
          to="/blades-in-the-dark-campaign-districts-six-towers"
          className="district-link"
        >
          Six Towers
        </Link>{" "}
        -{" "}
        <Link
          to="/blades-in-the-dark-campaign-districts-whitecrown"
          className="district-link"
        >
          Whitecrown
        </Link>
      </p>
    </fragment>
  );
};

export default NavDistricts;
